// src/store/index.js
import { createPinia } from 'pinia';

// 创建全局 Pinia 实例（与 main.js 中挂载的是同一个）
const pinia = createPinia();

export default pinia;
